import { render, staticRenderFns } from "./ProjectSummary.vue?vue&type=template&id=7d15b984&scoped=true"
import script from "./ProjectSummary.vue?vue&type=script&lang=js"
export * from "./ProjectSummary.vue?vue&type=script&lang=js"
import style0 from "./ProjectSummary.vue?vue&type=style&index=0&id=7d15b984&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d15b984",
  null
  
)

export default component.exports